import React, { useEffect, useState } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { DownArrow } from "../../../assets/images";
import { ItemsDataType } from "../../../redux/gstModule/gstModuleTypes";

type AppProps = {
  data: ItemsDataType[];
  tableHeader: TableHeadersType[];
};

const ItemTableBody = ({ data, tableHeader }: AppProps) => {
  const [newData, setNewData] = useState(JSON.parse(JSON.stringify(data)));

  useEffect(() => {
    if (data?.length > 0) {
      setNewData([...data]);
    }
  }, [data]);

  const renderItemTableRow = () => {
    const finalTableData =
      newData?.length &&
      newData?.map((dataItem: any, i: any) => {
        return (
          <>
            <tr>
              {tableHeader?.length &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header.value === "nature_of_income") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.nature_of_income}
                      </td>
                    );
                  } else if (header.value === "nature_of_expense") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.nature_of_expense}
                      </td>
                    );
                  } else if (header.value === "cost_center") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.cost_center}
                      </td>
                    );
                  } else if (header.value === "desc_as_per_bill") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.description_as_per_bill}
                      </td>
                    );
                  } else if (header.value === "sku_code") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.sku_code}
                      </td>
                    );
                  } else if (header.value === "hsn_sac_code") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.hsn_sac_code}
                      </td>
                    );
                  } else if (header.value === "unit") {
                    return (
                      <td className="data_inside_table">{dataItem?.unit}</td>
                    );
                  } else if (header.value === "gst_rate") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.gst_rate}
                      </td>
                    );
                  } else if (header.value === "rate") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.rate ? (+dataItem?.rate)?.toFixed(2) : 0}
                      </td>
                    );
                  } else if (header.value === "quantity") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.quantity}
                      </td>
                    );
                  } else if (header.value === "amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.amount ? (+dataItem?.amount)?.toFixed(2) : 0}
                      </td>
                    );
                  } else if (header.value === "discount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.discount
                          ? (+dataItem?.discount)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "taxable_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.taxable_value
                          ? (+dataItem?.taxable_value)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "gst_per") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.gst_percentage
                          ? (+dataItem?.gst_percentage)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "cess_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.cess_amount
                          ? (+dataItem?.cess_amount)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "cgst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.cgst_amount
                          ? (+dataItem?.cgst_amount)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "igst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.igst_amount
                          ? (+dataItem?.igst_amount)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "sgst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.sgst_amount
                          ? (+dataItem?.sgst_amount)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "total_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_value
                          ? (+dataItem?.total_value)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "invoice_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.invoice_value
                          ? (+dataItem?.invoice_value)?.toFixed(2)
                          : 0}
                      </td>
                    );
                  }
                })}
            </tr>
          </>
        );
      });
    return finalTableData;
  };

  return <>{renderItemTableRow()}</>;
};

export default ItemTableBody;
